import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { injectIntl } from 'react-intl'
import {
  fetchFormLevelEventValues,
  fetchFormList,
} from 'reducers/logbookForm/reducer'
import { TYPE_INPUT_BOOLEAN } from 'helpers/logbook'
import { formattValues } from 'helpers/logbookForm'
import MasterEventField from './MasterEvent'

class FormList extends Component {
  componentDidMount() {
    this.fetchFormList(this.props)
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite, activeDate, formList } = nextProps

    if (this.props.activeSite !== activeSite) {
      this.fetchFormList(nextProps)

      return false
    }

    if (
      this.props.formList !== formList ||
      this.props.activeDate !== activeDate
    ) {
      this.fetchFormLevelEventValues(nextProps)
    }

    return true
  }

  onItemClick = e => {
    const { onItemClick, formList } = this.props

    if (typeof onItemClick === 'function') {
      onItemClick(formList.get(e.currentTarget.dataset.index))
    }
  }

  fetchFormList = props => {
    const { activeSite } = props

    this.props.fetchFormList({
      site: activeSite,
    })
  }

  fetchFormLevelEventValues = props => {
    const {
      activeSite,
      activeDate,
      formList,
      fetchFormLevelEventValues,
    } = props
    const forms = []
    formList.forEach(item => {
      if (
        !item.needs_locus &&
        !item.needs_locus_group &&
        item.events.length === 1
      ) {
        forms.push({
          form: item.id,
          event: item.events[0].id,
        })
      }
    })

    if (forms.length > 0) {
      fetchFormLevelEventValues({
        params: {
          site: activeSite,
          date: activeDate.utc().format('YYYY-MM-DD'),
          forms,
        },
      })
    }
  }

  render() {
    if (!this.props.isShow) {
      return null
    }

    const {
      activeItem,
      activeAllEvents,
      activeEvent,
      onEventValueChange,
      onEventClick,
      formList,
      formEventValues,
      intl: { formatMessage },
    } = this.props
    const formListUnpack = formList.toArray()
    const formEventValuesUnpack = formattValues(
      formEventValues.toArray(),
      'form_id',
    )

    return (
      <List component="div" disablePadding className="lbf-list">
        {formListUnpack.map((item, index) => {
          const { events, needs_locus_group, needs_locus, id, title } = item
          const isEventOpen = activeEvent === id
          const onlyOneEvent = Array.isArray(events) && events.length === 1
          const hasSlaveEvents = onlyOneEvent && Array.isArray(events[0].slaves)
          const isLastLevelList =
            !needs_locus_group && !needs_locus && !hasSlaveEvents
          const clickHandler = hasSlaveEvents ? e => onEventClick(e, id) : null
          const onClick =
            !isLastLevelList || hasSlaveEvents ? this.onItemClick : clickHandler
          const selected = activeItem && activeItem.id === id

          return (
            <ListItem
              button
              key={index}
              data-index={index}
              onClick={onClick}
              className={cn('lbf-list-item', {
                'lbf-event-boolean':
                  TYPE_INPUT_BOOLEAN === (onlyOneEvent && events[0].type),
                'lbf-event-item': isLastLevelList,
                active: hasSlaveEvents && (isEventOpen || activeAllEvents),
                selected,
              })}>
              <ListItemText primary={formatMessage({ id: title })} />
              {isLastLevelList && !hasSlaveEvents && (
                <MasterEventField
                  index={index}
                  isEventOpen={isEventOpen || activeAllEvents}
                  hideTitle
                  eventInfo={{
                    ...events[0],
                    ...formEventValuesUnpack[id],
                    activeForm: item,
                  }}
                  onEventValueChange={onEventValueChange}
                  updateValuesList={() =>
                    this.fetchFormLevelEventValues(this.props)
                  }
                />
              )}
            </ListItem>
          )
        })}
      </List>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['logbookForm', 'activeDate']),
    formList: state.getIn(['logbookForm', 'formList']),
    formEventValues: state.getIn(['logbookForm', 'formEventValues']),
  }),
  {
    fetchFormList,
    fetchFormLevelEventValues,
  },
)(injectIntl(FormList))
